export const mentorConstants = {
  // create MENTOR data
  CREATE_MENTOR_ACTION_REQUEST: "CREATE_MENTOR_ACTION_REQUEST",
  CREATE_MENTOR_ACTION_SUCCESS: "CREATE_MENTOR_ACTION_SUCCESS",
  CREATE_MENTOR_ACTION_FAILURE: "CREATE_MENTOR_ACTION_FAILURE",

  // create mentor data
  UPDATE_MENTOR_PROFILE_ACTION_REQUEST: "UPDATE_MENTOR_PROFILE_ACTION_REQUEST",
  UPDATE_MENTOR_PROFILE_ACTION_SUCCESS: "UPDATE_MENTOR_PROFILE_ACTION_SUCCESS",
  UPDATE_MENTOR_PROFILE_ACTION_FAILURE: "UPDATE_MENTOR_PROFILE_ACTION_FAILURE",

  //mentor profile
  GET_MENTOR_PROFILE_DATA_ACTION_REQUEST:
    "GET_MENTOR_PROFILE_DATA_ACTION_REQUEST",
  GET_MENTOR_PROFILE_DATA_ACTION_SUCCESS:
    "GET_MENTOR_PROFILE_DATA_ACTION_SUCCESS",
  GET_MENTOR_PROFILE_DATA_ACTION_FAILURE:
    "GET_MENTOR_PROFILE_DATA_ACTION_FAILURE",

  // MENTOR EducationAL
  GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_REQUEST:
    "GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_REQUEST",
  GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_SUCCESS:
    "GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_SUCCESS",
  GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_FAILURE:
    "GET_MENTOR_ALL_EDUCATIONAL_DATA_ACTION_FAILURE",

  // MENTOR education by id
  GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_REQUEST:
    "GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_REQUEST",
  GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_SUCCESS:
    "GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_SUCCESS",
  GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_FAILURE:
    "GET_MENTOR_EDUCATION_BY_ID_DATA_ACTION_FAILURE",

  // update MENTOR education by id
  UPDATE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_REQUEST:
    "UPDATE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_REQUEST",
  UPDATE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_SUCCESS:
    "UPDATE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_SUCCESS",
  UPDATE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_FAILURE:
    "UPDATE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_FAILURE",

  // update MENTOR education by id
  CREATE_MENTOR_EDUCATION_DATA_ACTION_REQUEST:
    "CREATE_MENTOR_EDUCATION_DATA_ACTION_REQUEST",
  CREATE_MENTOR_EDUCATION_DATA_ACTION_SUCCESS:
    "CREATE_MENTOR_EDUCATION_DATA_ACTION_SUCCESS",
  CREATE_MENTOR_EDUCATION_DATA_ACTION_FAILURE:
    "CREATE_MENTOR_EDUCATION_DATA_ACTION_FAILURE",

  // MENTOR profession
  GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_REQUEST:
    "GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_REQUEST",
  GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_SUCCESS:
    "GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_SUCCESS",
  GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_FAILURE:
    "GET_MENTOR_ALL_PROFESSIONAL_DATA_ACTION_FAILURE",

  // MENTOR experience by id
  GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_REQUEST:
    "GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_REQUEST",
  GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_SUCCESS:
    "GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_SUCCESS",
  GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_FAILURE:
    "GET_MENTOR_PROFESSION_BY_ID_DATA_ACTION_FAILURE",

  ///update MENTOR experience by id
  UPDATE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_REQUEST:
    "UPDATE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_REQUEST",
  UPDATE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_SUCCESS:
    "UPDATE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_SUCCESS",
  UPDATE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_FAILURE:
    "UPDATE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_FAILURE",

  ///CREATE MENTOR experience by id
  CREATE_MENTOR_PROFESSION_DATA_ACTION_REQUEST:
    "CREATE_MENTOR_PROFESSION_DATA_ACTION_REQUEST",
  CREATE_MENTOR_PROFESSION_DATA_ACTION_SUCCESS:
    "CREATE_MENTOR_PROFESSION_DATA_ACTION_SUCCESS",
  CREATE_MENTOR_PROFESSION_DATA_ACTION_FAILURE:
    "CREATE_MENTOR_PROFESSION_DATA_ACTION_FAILURE",

  // delete MENTOR education by id
  DELETE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_REQUEST:
    "DELETE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_REQUEST",
  DELETE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_SUCCESS:
    "DELETE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_SUCCESS",
  DELETE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_FAILURE:
    "DELETE_MENTOR_EDUCATION_BY_ID_DATA_ACTION_FAILURE",

  ///delete MENTOR experience by id
  DELETE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_REQUEST:
    "DELETE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_REQUEST",
  DELETE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_SUCCESS:
    "DELETE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_SUCCESS",
  DELETE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_FAILURE:
    "DELETE_MENTOR_PROFESSION_BY_ID_DATA_ACTION_FAILURE",

  ///get all MENTOR skills
  GET_MENTOR_ALL_SKILLS_DATA_ACTION_REQUEST:
    "GET_MENTOR_ALL_SKILLS_DATA_ACTION_REQUEST",
  GET_MENTOR_ALL_SKILLS_DATA_ACTION_SUCCESS:
    "GET_MENTOR_ALL_SKILLS_DATA_ACTION_SUCCESS",
  GET_MENTOR_ALL_SKILLS_DATA_ACTION_FAILURE:
    "GET_MENTOR_ALL_SKILLS_DATA_ACTION_FAILURE",

  // MENTOR profession
  CREATE_MENTOR_SKILLS_DATA_ACTION_REQUEST:
    "CREATE_MENTOR_SKILLS_DATA_ACTION_REQUEST",
  CREATE_MENTOR_SKILLS_DATA_ACTION_SUCCESS:
    "CREATE_MENTOR_SKILLS_DATA_ACTION_SUCCESS",
  CREATE_MENTOR_SKILLS_DATA_ACTION_FAILURE:
    "CREATE_MENTOR_SKILLS_DATA_ACTION_FAILURE",

  // MENTOR profession
  DELETE_MENTOR_SKILL_BY_ID_DATA_ACTION_REQUEST:
    "DELETE_MENTOR_SKILL_BY_ID_DATA_ACTION_REQUEST",
  DELETE_MENTOR_SKILL_BY_ID_DATA_ACTION_SUCCESS:
    "DELETE_MENTOR_SKILL_BY_ID_DATA_ACTION_SUCCESS",
  DELETE_MENTOR_SKILL_BY_ID_DATA_ACTION_FAILURE:
    "DELETE_MENTOR_SKILL_BY_ID_DATA_ACTION_FAILURE",

  // MENTOR profession
  UPDATE_MENTOR_SKILL_BY_ID_DATA_ACTION_REQUEST:
    "UPDATE_MENTOR_SKILL_BY_ID_DATA_ACTION_REQUEST",
  UPDATE_MENTOR_SKILL_BY_ID_DATA_ACTION_SUCCESS:
    "UPDATE_MENTOR_SKILL_BY_ID_DATA_ACTION_SUCCESS",
  UPDATE_MENTOR_SKILL_BY_ID_DATA_ACTION_FAILURE:
    "UPDATE_MENTOR_SKILL_BY_ID_DATA_ACTION_FAILURE",

  //get dashboard details
  GET_MENTOR_DASHBOARD_DETAILS_ACTION_REQUEST:
    "GET_MENTOR_DASHBOARD_DETAILS_ACTION_REQUEST",
  GET_MENTOR_DASHBOARD_DETAILS_ACTION_SUCCESS:
    "GET_MENTOR_DASHBOARD_DETAILS_ACTION_SUCCESS",
  GET_MENTOR_DASHBOARD_DETAILS_ACTION_FAILURE:
    "GET_MENTOR_DASHBOARD_DETAILS_ACTION_FAILURE",

  //get dashboard details
  GET_MENTOR_KANBANBOARD_DETAILS_ACTION_REQUEST:
    "GET_MENTOR_KANBANBOARD_DETAILS_ACTION_REQUEST",
  GET_MENTOR_KANBANBOARD_DETAILS_ACTION_SUCCESS:
    "GET_MENTOR_KANBANBOARD_DETAILS_ACTION_SUCCESS",
  GET_MENTOR_KANBANBOARD_DETAILS_ACTION_FAILURE:
    "GET_MENTOR_KANBANBOARD_DETAILS_ACTION_FAILURE",

  //view mentor profile
  VIEW_MENTOR_PROFILE_DATA_ACTION_REQUEST:
    "VIEW_MENTOR_PROFILE_DATA_ACTION_REQUEST",
  VIEW_MENTOR_PROFILE_DATA_ACTION_SUCCESS:
    "VIEW_MENTOR_PROFILE_DATA_ACTION_SUCCESS",
  VIEW_MENTOR_PROFILE_DATA_ACTION_FAILURE:
    "VIEW_MENTOR_PROFILE_DATA_ACTION_FAILURE",

  // MENTOR PORTFOLIO
  GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_REQUEST:
    "GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_REQUEST",
  GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_SUCCESS:
    "GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_SUCCESS",
  GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_FAILURE:
    "GET_MENTOR_ALL_PORTFOLIO_DATA_ACTION_FAILURE",

  // MENTOR portfolio by id
  GET_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST:
    "GET_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST",
  GET_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS:
    "GET_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS",
  GET_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE:
    "GET_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE",

  ///update MENTOR portfolio by id
  UPDATE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST:
    "UPDATE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST",
  UPDATE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS:
    "UPDATE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS",
  UPDATE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE:
    "UPDATE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE",

  ///CREATE MENTOR portfolio by id
  CREATE_MENTOR_PORTFOLIO_DATA_ACTION_REQUEST:
    "CREATE_MENTOR_PORTFOLIO_DATA_ACTION_REQUEST",
  CREATE_MENTOR_PORTFOLIO_DATA_ACTION_SUCCESS:
    "CREATE_MENTOR_PORTFOLIO_DATA_ACTION_SUCCESS",
  CREATE_MENTOR_PORTFOLIO_DATA_ACTION_FAILURE:
    "CREATE_MENTOR_PORTFOLIO_DATA_ACTION_FAILURE",

  // delete MENTOR portfolio by id
  DELETE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST:
    "DELETE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_REQUEST",
  DELETE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS:
    "DELETE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_SUCCESS",
  DELETE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE:
    "DELETE_MENTOR_PORTFOLIO_BY_ID_DATA_ACTION_FAILURE",

  GET_ASSIGNED_CANDIDATES_ACTION_REQUEST:
    "GET_ASSIGNED_CANDIDATES_ACTION_REQUEST",
  GET_ASSIGNED_CANDIDATES_ACTION_SUCCESS:
    "GET_ASSIGNED_CANDIDATES_ACTION_SUCCESS",
  GET_ASSIGNED_CANDIDATES_ACTION_FAILURE:
    "GET_ASSIGNED_CANDIDATES_ACTION_FAILURE",

  GET_INVITED_CANDIDATES_ACTION_REQUEST:
    "GET_INVITED_CANDIDATES_ACTION_REQUEST",
  GET_INVITED_CANDIDATES_ACTION_SUCCESS:
    "GET_INVITED_CANDIDATES_ACTION_SUCCESS",
  GET_INVITED_CANDIDATES_ACTION_FAILURE:
    "GET_INVITED_CANDIDATES_ACTION_FAILURE",

};
